import { Route, Routes } from "react-router-dom";
import AdminNewDashboard from "routes/admin/dashboard/AdminNewDashboard";
import MachineManagement from "routes/admin/store/MachineManagement";
import StoreConfirmYnManagement from "routes/admin/store/StoreConfirmYnManagement";
import MokStdRedirect from "routes/front/test/mok/MokStdRedirect";
import MokStdRequest from "routes/front/test/mok/MokStdRequest";
import PartnersBrandList from "routes/partners/brand/PartnersBrandList";
import PartnersBrandListDetail from "routes/partners/brand/PartnersBrandListDetail";
import PartnersBrandRegistration from "routes/partners/brand/PartnersBrandRegistration";
import PartnersCategoryCreate from "routes/partners/category/PartnersCategoryCreate";
import PartnersCategoryRegister from "routes/partners/category/PartnersCategoryRegister";
import PartnersDashboard from "routes/partners/dashboard/PartnersDashboard";
import PartnersVendorInquireList from "routes/partners/inquire/PartnersVendorInquireList";
import PartnersLayout from "routes/partners/PartnersLayout";
import PartnersProductDetail from "routes/partners/product/PartnersProductDetail";
import PartnersProductList from "routes/partners/product/PartnersProductList";
import PartnersProductRegister from "routes/partners/product/PartnersProductRegister";
import PartnersHome from "routes/partners/sales/PartnersHome";
import PartnersSalesLayout from "routes/partners/sales/PartnersSalesLayout";
import PartnersSalesSettlement from "routes/partners/sales/PartnersSalesSettlement";
import PartnersStoreDetail from "routes/partners/sales/PartnersStoreDetail";
import PartnersMachineManagement from "routes/partners/store/PartnersMachineManagement";
import PartnersSalesStatistics from "routes/partners/store/PartnersSalesStatistics";
import PartnersStoreManagement from "routes/partners/store/PartnersStoreManagement";
import PartnersStoreManagementDetail from "routes/partners/store/PartnersStoreManagementDetail";
import PartnersStoreRegister from "routes/partners/store/PartnersStoreRegister";
import StoreDetailWrapper from "routes/partners/store/StoreSettlementWrapper";
import PartnersVendingDetail from "routes/partners/vending/PartnersVendingDetail";
import PartnersVendingManagement from "routes/partners/vending/PartnersVendingManagement";
import PartnersVendingMapping from "routes/partners/vending/PartnersVendingMapping";
import PartnersVendingRegister from "routes/partners/vending/PartnersVendingRegister";
import RequireAuth from "shared/utils/RequireAuth";
import RequirePartnersAuth from "shared/utils/RequirePartnersAuth";


function PartnersRouter({ allowedRoles }) {
    const storeId = 'root';
    return (
        <Routes>
            <Route path="" element={<RequirePartnersAuth allowedRoles={allowedRoles} />} >
                <Route path="" element={<PartnersLayout />} >
                    <Route index element={<PartnersDashboard />} />
                    <Route path="store/register" element={<PartnersStoreRegister />} />
                    <Route path="store/confirmYnManagement" element={<StoreConfirmYnManagement />} />
                    <Route path="store/sales" element={<PartnersSalesLayout />} >
                        <Route path="" element={<PartnersHome />} />
                        <Route path="detail/:storeId" element={<StoreDetailWrapper />} />
                        <Route path={"storeManagement/:storeId"} element={<PartnersStoreDetail />} />
                        <Route path="settlement" element={<PartnersSalesSettlement />} />
                        <Route path="salesStatistics" element={<PartnersSalesStatistics />} />
                    </Route>

                    <Route path="product/register" element={<PartnersProductRegister />} />
                    <Route path="product/list" element={<PartnersProductList />} />
                    <Route path="product/list/:detail" element={<PartnersProductDetail />} />

                    <Route path="category/create" element={<PartnersCategoryCreate />} />
                    <Route path="category/register" element={<PartnersCategoryRegister />} />

                    <Route path="brand/register" element={<PartnersBrandRegistration />} />
                    <Route path="brand/list" element={<PartnersBrandList />} />
                    <Route path="brand/list/:detail" element={<PartnersBrandListDetail />} />

                    <Route path="vendor/inquire/list" element={<PartnersVendorInquireList />} />

                    {/* <Route path="vending/list" element={<PartnersVendingManagement />} /> */}
                    {/* <Route path="vending/list/detail" element={<PartnersVendingDetail />} /> */}
                    <Route path="vending/register" element={<PartnersVendingRegister />} />
                    <Route path="vending/mapping" element={<PartnersVendingMapping />} />
                    <Route path="vending/management" element={<PartnersStoreManagement />} />
                    <Route path="vending/management/detail" element={<PartnersStoreManagementDetail />} />
                    <Route path="vending/management/detail/:machineId" element={<MachineManagement />} />
                </Route>
            </Route>
        </Routes>
    );
}
export default PartnersRouter;
